/* eslint-disable lines-around-comment */
import { makeStyles } from '@material-ui/styles';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
// @ts-ignore
import { isSupported as isAvModerationSupported } from '../../../av-moderation/functions';
// @ts-ignore
import { Avatar } from '../../../base/avatar';
import ContextMenu from '../../../base/components/context-menu/ContextMenu';
import ContextMenuItemGroup from '../../../base/components/context-menu/ContextMenuItemGroup';
import { isIosMobileBrowser, isMobileBrowser } from '../../../base/environment/utils';
import { IconShareVideo } from '../../../base/icons/svg';
import { MEDIA_TYPE } from '../../../base/media/constants';
import { PARTICIPANT_ROLE } from '../../../base/participants/constants';
import { getLocalParticipant } from '../../../base/participants/functions';
// @ts-ignore
import { isParticipantAudioMuted } from '../../../base/tracks';
// @ts-ignore
import { getBreakoutRooms, getCurrentRoomId, isInBreakoutRoom } from '../../../breakout-rooms/functions';
// @ts-ignore
import { setVolume } from '../../../filmstrip/actions.web';
// @ts-ignore
import { isStageFilmstripAvailable } from '../../../filmstrip/functions.web';
// @ts-ignore
import { isForceMuted } from '../../../participants-pane/functions';
// @ts-ignore
import { requestRemoteControl, stopController } from '../../../remote-control';
// @ts-ignore
import { stopSharedVideo } from '../../../shared-video/actions.any';
// @ts-ignore
import { showOverflowDrawer } from '../../../toolbox/functions.web';
// @ts-ignore
import { REMOTE_CONTROL_MENU_STATES } from './RemoteControlButton';
// @ts-ignore
import SendToRoomButton from './SendToRoomButton';
import { AskToUnmuteButton, ConnectionStatusButton, GrantModeratorButton, MuteButton, MuteEveryoneElseButton, MuteEveryoneElsesVideoButton, MuteVideoButton, KickButton, PrivateMessageMenuButton, RemoteControlButton, TogglePinToStageButton, VolumeSlider
// @ts-ignore
 } from './';
const useStyles = makeStyles((theme) => {
    return {
        text: {
            color: theme.palette.text02,
            padding: '10px 16px',
            height: '40px',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            boxSizing: 'border-box'
        }
    };
});
const ParticipantContextMenu = ({ className, closeDrawer, drawerParticipant, localVideoOwner, offsetTarget, onEnter, onLeave, onSelect, participant, remoteControlState, thumbnailMenu }) => {
    var _a, _b;
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const styles = useStyles();
    const localParticipant = useSelector(getLocalParticipant);
    const _isModerator = Boolean((localParticipant === null || localParticipant === void 0 ? void 0 : localParticipant.role) === PARTICIPANT_ROLE.MODERATOR);
    const _isAudioForceMuted = useSelector(state => isForceMuted(participant, MEDIA_TYPE.AUDIO, state));
    const _isVideoForceMuted = useSelector(state => isForceMuted(participant, MEDIA_TYPE.VIDEO, state));
    const _isAudioMuted = useSelector(state => isParticipantAudioMuted(participant, state));
    const _overflowDrawer = useSelector(showOverflowDrawer);
    const { remoteVideoMenu = {}, disableRemoteMute, startSilent } = useSelector((state) => state['features/base/config']);
    const { disableKick, disableGrantModerator, disablePrivateChat } = remoteVideoMenu;
    const { participantsVolume } = useSelector((state) => state['features/filmstrip']);
    const _volume = (_b = (((_a = participant === null || participant === void 0 ? void 0 : participant.local) !== null && _a !== void 0 ? _a : true) ? undefined
        : (participant === null || participant === void 0 ? void 0 : participant.id) ? participantsVolume[participant === null || participant === void 0 ? void 0 : participant.id] : undefined)) !== null && _b !== void 0 ? _b : 1;
    const isBreakoutRoom = useSelector(isInBreakoutRoom);
    const isModerationSupported = useSelector(isAvModerationSupported);
    const stageFilmstrip = useSelector(isStageFilmstripAvailable);
    const _currentRoomId = useSelector(getCurrentRoomId);
    const _rooms = Object.values(useSelector(getBreakoutRooms));
    const _onVolumeChange = useCallback(value => {
        dispatch(setVolume(participant.id, value));
    }, [setVolume, dispatch]);
    const clickHandler = useCallback(() => onSelect(true), [onSelect]);
    const _onStopSharedVideo = useCallback(() => {
        clickHandler();
        dispatch(stopSharedVideo());
    }, [stopSharedVideo]);
    const _getCurrentParticipantId = useCallback(() => {
        var _a;
        const drawer = _overflowDrawer && !thumbnailMenu;
        return (_a = (drawer ? drawerParticipant === null || drawerParticipant === void 0 ? void 0 : drawerParticipant.participantID : participant === null || participant === void 0 ? void 0 : participant.id)) !== null && _a !== void 0 ? _a : '';
    }, [thumbnailMenu, _overflowDrawer, drawerParticipant, participant]);
    const buttons = [];
    const buttons2 = [];
    const showVolumeSlider = !startSilent
        && !isIosMobileBrowser()
        && (_overflowDrawer || thumbnailMenu)
        && typeof _volume === 'number'
        && !isNaN(_volume);
    const fakeParticipantActions = [{
            accessibilityLabel: t('toolbar.stopSharedVideo'),
            icon: IconShareVideo,
            onClick: _onStopSharedVideo,
            text: t('toolbar.stopSharedVideo')
        }];
    if (_isModerator) {
        if ((thumbnailMenu || _overflowDrawer) && isModerationSupported && _isAudioMuted) {
            buttons.push(React.createElement(AskToUnmuteButton, { isAudioForceMuted: _isAudioForceMuted, isVideoForceMuted: _isVideoForceMuted, key: 'ask-unmute', participantID: _getCurrentParticipantId() }));
        }
        if (!disableRemoteMute) {
            buttons.push(React.createElement(MuteButton, { key: 'mute', participantID: _getCurrentParticipantId() }));
            buttons.push(React.createElement(MuteEveryoneElseButton, { key: 'mute-others', participantID: _getCurrentParticipantId() }));
            buttons.push(React.createElement(MuteVideoButton, { key: 'mute-video', participantID: _getCurrentParticipantId() }));
            buttons.push(React.createElement(MuteEveryoneElsesVideoButton, { key: 'mute-others-video', participantID: _getCurrentParticipantId() }));
        }
        if (!disableGrantModerator && !isBreakoutRoom) {
            buttons2.push(React.createElement(GrantModeratorButton, { key: 'grant-moderator', participantID: _getCurrentParticipantId() }));
        }
        if (!disableKick) {
            buttons2.push(React.createElement(KickButton, { key: 'kick', participantID: _getCurrentParticipantId() }));
        }
    }
    if (stageFilmstrip) {
        buttons2.push(React.createElement(TogglePinToStageButton, { key: 'pinToStage', participantID: _getCurrentParticipantId() }));
    }
    if (!disablePrivateChat) {
        buttons2.push(React.createElement(PrivateMessageMenuButton, { key: 'privateMessage', participantID: _getCurrentParticipantId() }));
    }
    if (thumbnailMenu && isMobileBrowser()) {
        buttons2.push(React.createElement(ConnectionStatusButton, { key: 'conn-status', participantId: _getCurrentParticipantId() }));
    }
    if (thumbnailMenu && remoteControlState) {
        let onRemoteControlToggle = null;
        if (remoteControlState === REMOTE_CONTROL_MENU_STATES.STARTED) {
            onRemoteControlToggle = () => dispatch(stopController(true));
        }
        else if (remoteControlState === REMOTE_CONTROL_MENU_STATES.NOT_STARTED) {
            onRemoteControlToggle = () => dispatch(requestRemoteControl(_getCurrentParticipantId()));
        }
        buttons2.push(React.createElement(RemoteControlButton, { key: 'remote-control', onClick: onRemoteControlToggle, participantID: _getCurrentParticipantId(), remoteControlState: remoteControlState }));
    }
    const breakoutRoomsButtons = [];
    if (!thumbnailMenu && _isModerator) {
        _rooms.forEach(room => {
            if (room.id !== _currentRoomId) {
                breakoutRoomsButtons.push(React.createElement(SendToRoomButton, { key: room.id, onClick: clickHandler, participantID: _getCurrentParticipantId(), room: room }));
            }
        });
    }
    return (React.createElement(ContextMenu, { className: className, entity: participant, hidden: thumbnailMenu ? false : undefined, inDrawer: thumbnailMenu && _overflowDrawer, isDrawerOpen: Boolean(drawerParticipant), offsetTarget: offsetTarget, onClick: onSelect, onDrawerClose: thumbnailMenu ? onSelect : closeDrawer, onMouseEnter: onEnter, onMouseLeave: onLeave },
        !thumbnailMenu && _overflowDrawer && drawerParticipant && React.createElement(ContextMenuItemGroup, { actions: [{
                    accessibilityLabel: drawerParticipant.displayName,
                    customIcon: React.createElement(Avatar, { participantId: drawerParticipant.participantID, size: 20 }),
                    text: drawerParticipant.displayName
                }] }),
        (participant === null || participant === void 0 ? void 0 : participant.isFakeParticipant) ? localVideoOwner && (React.createElement(ContextMenuItemGroup, { actions: fakeParticipantActions })) : (React.createElement(React.Fragment, null,
            buttons.length > 0 && (React.createElement(ContextMenuItemGroup, null, buttons)),
            React.createElement(ContextMenuItemGroup, null, buttons2),
            showVolumeSlider && (React.createElement(ContextMenuItemGroup, null,
                React.createElement(VolumeSlider, { initialValue: _volume, key: 'volume-slider', onChange: _onVolumeChange }))),
            breakoutRoomsButtons.length > 0 && (React.createElement(ContextMenuItemGroup, null,
                React.createElement("div", { className: styles.text }, t('breakoutRooms.actions.sendToBreakoutRoom')),
                breakoutRoomsButtons))))));
};
export default ParticipantContextMenu;
